import { render } from "./hrm-salary-component-modal.vue?vue&type=template&id=3477e67e"
import script from "./hrm-salary-component-modal.vue?vue&type=script&lang=js"
export * from "./hrm-salary-component-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__